import BaseApiClient from '../BaseApiClient';

export interface DocsSurface {
  title: string;
  description: string;
  url: string;
}

/**
 * Documentation surfaces shown as tiles on the Find APIs page. The CRM API proxies
 * these from the docs service, filtered to the surfaces the current user is entitled
 * to see (visibility is resolved by the docs service from the forwarded session).
 */
export class ApiDocsSurfaces extends BaseApiClient {
  async all(): Promise<DocsSurface[]> {
    const res = await this.client.get('/docs-surfaces');
    return res.data?.data ?? [];
  }
}

export { docsSurfacesQueryKeys } from './query-keys';
export { useDocsSurfacesQuery } from './use-docs-surfaces-queries';
